import Vue from 'vue';
import axios from "axios";
import _orderby from "lodash/orderBy";
import _findIndex from "lodash/findIndex"
import _find from "lodash/find"
import {
    format as date_format,
    parse as date_parse,
    eachDay as date_eachDay,
    subDays as date_subDays,
    subWeeks as date_subWeeks,
    subMonths as date_subMonths
} from "date-fns";

const tzoffset = new Date().getTimezoneOffset() * 60 * 1000;

// result.data.reportconfig.showsummary = !result.data.reportconfig.hidesummary;
// result.data.reportconfig.showchecks = !result.data.reportconfig.hidechecks;
// result.data.reportconfig.shownote = !result.data.reportconfig.hidenote;
// result.data.reportconfig.showevents = !result.data.reportconfig.hideevents;
// result.data.reportconfig.showcheckuptime = !result.data.reportconfig.hidecheckuptime;
const boolfields = {
    hidesummary: 'showsummary',
    hidechecks: 'showchecks',
    hidenote: 'shownote',
    hideevents: 'showevents',
    hidecheckuptime: 'showcheckuptime'
};

export default {
    namespaced: true,
    state: {
        baseurl: '/reports/statusevents/',
        eventParams: false,
        reportChecks: false, // jobs list
        reportConfig: false,
        reportEvents: false,
        message: false,
        accessphrase: false,
        error: false
        },
    mutations: {
        removeCheck (state, val) {
            if (typeof val === "object") val = val.checkid;
            if (!val) return;
            let idx = _findIndex(state.reportChecks, { _id: val });
            if (idx > -1) {
                state.reportChecks.splice(idx, 1);
            }
        },
        setChecksList (state, val) {
            state.reportChecks = [...val];
        },
        setCheck (state, val) {
            let idx;
            if (val && (val.idx || val.idx === 0) && val.val) {
                idx = val.idx;
                val = val.val;
            }
            // console.log('setCheck', idx, val);
            if (!val || !val._id ){
                // console.log("bad val", val);
                return;
            }
            idx = (idx == idx - 0) ? idx : _findIndex(state.reportChecks, { _id: val.checkid || val._id });
            if (idx > -1) {
                val.key = val._id + "-" + Date.now();
                // console.log('setting', val);
                Vue.set(state.reportChecks, idx, val);
            } else {
                state.reportChecks = state.reportChecks.concat(val);
            }
        },
        setError (state, val) {
            state.error = Object.assign({}, val);
        },
        setEventDays (state, val) {
            // console.log('setEventDay', val);
            let found;
            for(let k in val){
                if(state.reportEvents[k]){
                    for(let i in state.reportEvents[k].events){
                        if(!_find(val[k].events, {start: state.reportEvents[k].events[i].start} ) ){
                            // console.log(k, state.reportEvents[k].events[i])
                            val[k].events.push(state.reportEvents[k].events[i]);
                            found = true;
                        }
                    }
                    if(found) val[k].events = _orderby(val[k].events, ['start'], ['desc']);
                }
                Vue.set(state.reportEvents, k, val[k]);
            }
        },
        setEventParams (state, val) {
            state.eventParams = {...val};
        },
        setEventsList (state, val) {
            state.reportEvents = Object.assign({}, state.reportEvents, val);
        },
        setMessage (state, val) {
            state.message = Object.assign({}, state.message, val);
            setTimeout( () => {
                let m = Object.assign({}, state.message);
                if (val && val.id && m[val.id]) delete m[val.id];
                state.message = m;
            }, 3000 )
        },
        setAccessPhrase (state, val) {
            state.accessphrase = val;
        },
        setReportConfig (state, val) {
            val = Object.assign({}, val);

            for(let k in val){
                if(boolfields[k]){
                    val[k] = !!val[k]; // force to boolean, mostly to avoid undefined values
                    val[boolfields[k]] = !val[k];
                }
            }

            if (val.setCheck) delete val.setCheck;
            if (val.removeCheck) delete val.removeCheck;
            if (val.addCheck) delete val.addCheck;
            if (val.options) delete val.options;
            // console.log('mutating', val)
            state.reportConfig = val;
        }
    },
    actions: {
        /**
         * Add a check to the report.
         * Uses setCheck call on account module report update to add the check to the report's list
         * To update a check already on the report, use setReportCheck instead.
         * @param {*} params
         * @param {*} options
         *              checkid
         *              report
         */
        addReportCheck ({ commit, state }, options) {
            if(!options) return Promise.reject("Missing parameters");

            commit('setCheck', options)
            let reportConfig = Object.assign({}, state.reportConfig);
            reportConfig.setCheck = {
                checkid: options.checkid,
                report: options.report
            };
            reportConfig.checks = "keep";

            return axios.post('/account/reporting/status', reportConfig)
                .then( (result) => {
                    this.dispatch('reports_statusevents/listChecks', { skipconfig: true });
                    if (result) commit('setError', false);
                })
                .catch( function (error){
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.status,
                        statusText: error.statusText,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable")
                    });
                })
        },
        listChecks ({ commit, state }, options) {
            options = options || {};
            let reportid = options.reportid || (state.reportConfig && state.reportConfig.reportid);
            if (!reportid){
                // console.log('missing reportid from listChecks', options);
                return Promise.resolve();
            }
            if(options.accessphrase){
                commit('setAccessPhrase', options.accessphrase);
            }

            let params = {
                offset: tzoffset
            }
            if(state.accessphrase && state.accessphrase.length) params.accessphrase = state.accessphrase;

            return axios.post(state.baseurl + reportid + "/listchecks", params)
                .then( (result) => {
                    if (result && result.data){
                        if (result.data.reportconfig && !options.skipconfig){
                            if (!result.data.reportconfig.displaymetric) result.data.reportconfig.displaymetric = "Uptime for today and 30 days";

                            // this is moved to the mutation
                            // result.data.reportconfig.showsummary = !result.data.reportconfig.hidesummary;
                            // result.data.reportconfig.showchecks = !result.data.reportconfig.hidechecks;
                            // result.data.reportconfig.shownote = !result.data.reportconfig.hidenote;
                            // result.data.reportconfig.showevents = !result.data.reportconfig.hideevents;
                            // result.data.reportconfig.showcheckuptime = !result.data.reportconfig.hidecheckuptime;

                            commit('setReportConfig', result.data.reportconfig);
                        }
                        if (result.data.jobs && !options.skipjobs){
                            let datalength = result.data.jobs.length || 0;
                            let statelength = (state.reportChecks && state.reportChecks.length) || 0;

                            const handleloop = (i) => {
                                // console.log('handleloop',i)
                                if(!result.data.jobs[i]) return;
                                if(
                                    result.data.jobs[i]._id !== state.reportChecks[i]._id ||
                                    result.data.jobs[i].modified > state.reportChecks[i].modified ||
                                    ((result.data.jobs[i].result && result.data.jobs[i].result.s) !=  (state.reportChecks[i].result && state.reportChecks[i].result.s)) ||
                                    result.data.jobs[i].description !== state.reportChecks[i].description
                                ){
                                    commit('setCheck', {idx: i, val: result.data.jobs[i]});
                                    // console.log('setting update for', i, result.data.jobs[i]._id, result.data.jobs[i].label);
                                } else {
                                    // console.log('nochanges', i, result.data.jobs[i]._id, result.data.jobs[i].label);
                                }
                                i++;
                                setTimeout(function(){ handleloop(i); }, 0)
                            };

                            if(statelength && statelength === datalength){
                                handleloop(0);
                                // for(var i=0;i<datalength;i++){
                                //     if(
                                //         result.data.jobs[i]._id !== state.reportChecks[i]._id ||
                                //         result.data.jobs[i].modified > state.reportChecks[i].modified ||
                                //         ((result.data.jobs[i].result && result.data.jobs[i].result.s) !=  (state.reportChecks[i].result && state.reportChecks[i].result.s))
                                //     ){
                                //         commit('setCheck', {idx: i, val: result.data.jobs[i]});
                                //     } else {
                                //         console.log('nochanges');
                                //     }
                                // }
                            } else {
                                // console.log('setting list of checks', result && result.data && result.data.jobs && result.data.jobs.length)
                                commit('setChecksList', result.data.jobs);
                            }
                        }
                        if(result.data.jobs || result.data.reportconfig) commit('setError', false);
                    }
                })
                .catch( (error) => {
                    console.log("ERROR caught in listChecks", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        type: error.response.data && error.response.data.type,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable"),
                        login: error.response.data && error.response.data.login,
                    });
                })
        },
        listEvents ({ commit, state }, options) {
            options = options || {};
            let reportid = options.reportid || (state.reportConfig && state.reportConfig.reportid);
            if (!reportid){
                console.log('missing reportid from listEvents', options);
                return Promise.resolve();
            }
            let params = {
                offset: (options.offset || options.offset === 0) ? options.offset : tzoffset
            };
            // if(options.page && options.page == options.page - 0) params.eventpage = options.page;
            const fields = {
                eventpage: function(v){ return (options.eventpage == options.eventpage - 0) ? options.eventpage : undefined; },
                start: true,
                end: true,
                eventsinterval: true
            };
            for(let f in fields){
                if(options[f]){ params[f] = (typeof fields[f] === "function") ? fields[f](options[f]) : options[f]; }
            }
            params.limit = (state.reportConfig && state.reportConfig.eventslimit ) || 50;
            // console.log('listEvents', options, params);

            return axios.post(state.baseurl + reportid + "/listevents", params)
                .then( (result) => {
                    if(result && result.data){
                        let eventParams;
                        if(result.data.params){
                            eventParams = Object.assign(result.data.params);
                        }
                        if(result.data.events) result.data = result.data.events;
                        let days = {};
                        let now = new Date();

                        let laststart = eventParams.laststart;
                        if(eventParams){
                            // eventParams.laststart = laststart;
                            commit('setEventParams', eventParams);
                        }

                        options.eventsinterval = options.eventsinterval || state.reportConfig.eventsinterval || "months";
                        options.showemptyeventdays = options.showemptyeventdays || state.reportConfig.showemptyeventdays || false;
                        if(options.showemptyeventdays){

                            // params.eventpage =  params.eventpage || 0
                            // if(!options.startdate){
                            //     if(options.eventsinterval === "days"){
                            //         options.startdate = date_subDays(now, params.eventpage + 1);
                            //     }else if (options.eventsinterval === "weeks"){
                            //         options.startdate =  date_subWeeks(now, params.eventpage + 1);
                            //     } else {
                            //         options.startdate =  date_subMonths(now, params.eventpage + 1);
                            //     }
                            // }
                            // if (!options.enddate) {
                            //     if(eventParams.more){
                            //         options.enddate = laststart;
                            //     } else if (!params.eventpage) {
                            //         options.enddate = now;
                            //     } else if(options.eventsinterval === "days"){
                            //         options.enddate = date_subDays(now, params.eventpage );
                            //     }else if (options.eventsinterval === "weeks"){
                            //         options.enddate =  date_subWeeks(now, params.eventpage );
                            //     } else {
                            //         options.enddate =  date_subMonths(now, params.eventpage );
                            //     }
                            // }
                            let datelist = date_eachDay(
                                eventParams.more ? eventParams.laststart : eventParams.startdate,
                                eventParams.enddate
                            );
                            let d = datelist.length;
                            while( d-- ){
                                let day = date_format(datelist[d], 'YYYY-MM-DD');
                                if( !state.reportEvents[day]) days[day] = {events: []} ;
                            }
                        }

                        let len = result.data.length;
                        for( let i=0; i < len; i++ ){
                            if(result.data[i].type === "start") continue;
                            result.data[i].startlocal = result.data[i].start - tzoffset;
                            if (result.data[i].end) result.data[i].endlocal = result.data[i].end - tzoffset;
                            let thedate = date_format(date_parse(result.data[i].startlocal), 'YYYY-MM-DD');
                            result.data[i].key = result.data[i].jobid + "-" + result.data[i].start;
                            if(result.data[i].data){
                                let dlen = result.data[i].data.length
                                for(let j=0; j < dlen; j++){
                                    result.data[i].data[j].key =  result.data[i].key + '-' + result.data[i].data[j].created;
                                    // result.data[i].data[j] = {
                                    //     id: result.data[i].data[j].jobid,
                                    //     httpstatus: result.data[i].data[j].httpstatus,
                                    //     data: result.data[i].data[j].data
                                    // }
                                }

                            }
                            days[thedate] = days[thedate] || {events: [], key: thedate + "-" + now};
                            days[thedate].events.push(result.data[i]);
                        }
                        if(!state.reportEvents || Object.keys(days).length > 14){
                            // console.log('calling commit for setEventsList', days);
                            commit('setEventsList', days);
                        } else {
                            // console.log('calling commit for setEventDays');
                            commit('setEventDays', days);
                        }
                        commit('setError', false);
                    }
                })
                .catch( (error) => {
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable")
                    });
                })
        },
        removeReportCheck ({ commit, state }, options) {
            if (!options){
                return Promise.reject(new Error('Missing parameters'));
            }
            commit('removeCheck', options);

            let reportConfig = Object.assign({}, { checks: "keep", checkRemove: options }, state.reportConfig);

            return axios.post('/account/reporting/status', reportConfig)
            .then( (result) => {
                this.dispatch('reports_statusevents/listChecks', { skipconfig: true });
                if(result) commit('setError', false);
            })
            .catch( function (error){
                console.log("ERROR", error.response || error);
                error = (error && error.response && error) || {
                    response: 500,
                    data: {}
                }
                commit('setError', {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    message: ((error.response.data && error.response.data.error) || "Report unavailable")
                });
            })
        },
        setCheckReorder ({ commit, state }, options) {
            // this method does not need to set store state, because the UI has state handled in the component

            let reportConfig = Object.assign({}, state.reportConfig, options);

            let sendall;
            let checks = [];
            let clength = state.reportChecks.length;
            for (let i = 0; i < clength; i++) {
                if (!state.reportChecks[i].report || state.reportChecks[i].report.order === undefined) sendall = true;
                let record = {
                    checkid: state.reportChecks[i]._id,
                    order: i
                }
                if (state.reportChecks[i].report) record = Object.assign(state.reportChecks[i].report, record);
                checks.push(record);
            }

            if (sendall) {
                reportConfig.checks = checks;
                if (reportConfig.moved) delete reportConfig.moved;
            } else {
                reportConfig.checks = "keep";
            }

            // return Promise.reject(new Error("Let's stop here."));
            return axios.post('/account/reporting/status', reportConfig)
                .then( (result) => {
                    this.dispatch('reports_statusevents/listChecks', { skipconfig: true });
                    if(result) commit('setError', false);
                })
                .catch( function (error){
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable")
                    });
                })

        },
        /**
         * Update properties for an existing individual check on the report.
         * To add a check to the report, use addReportCheck instead.
         * To work with report configuration not related to individual checks, use setReportconfig
         * @param {*} param0
         * @param {*} options
         *              checkid required
         */
        setReportCheck ({ commit, state }, options) {
            if (!options){
                return Promise.reject(new Error('Missing parameters'));
            }
            // This is only used for updates.
            let idx = _findIndex(state.reportChecks, { _id: options.checkid });
            if (idx < 0) return Promise.reject(new Error('Missing check'));

            options.setCheck.order = idx;

            let record = Object.assign({}, state.reportChecks[idx]);
            record.report = Object.assign({}, record.report, options.setCheck);
            commit('setCheck', { idx: idx, val: record });

            let reportConfig = Object.assign({}, state.reportConfig, options);
            reportConfig.checks = "keep";

            return axios.post('/account/reporting/status', reportConfig)
                .then( (result) => {
                    this.dispatch('reports_statusevents/listChecks', { skipconfig: true });
                    if(result) commit('setError', false);
                })
                .catch( function (error){
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable")
                    });
                })

        },
        /**
         * Set configuration options on a report.
         * To set options specific to an individual check, use setReportCheck instead.
         * @param {*} param0
         * @param {*} options
         */
        setReportConfig ({ commit, state }, options) {
            if (!options){
                return Promise.reject(new Error('Missing parameters'));
            }

            // this is used to make checkbox handling easier
            if (options.hidesummary !== undefined) options.showsummary = !options.hidesummary;
            if (options.hidechecks !== undefined) options.showchecks = !options.hidechecks;
            if (options.hidenote !== undefined) options.shownote = !options.hidenote;
            if (options.hideevents !== undefined) options.showevents = !options.hideevents;

            let reportConfig = Object.assign({}, state.reportConfig, options);

            commit('setReportConfig', reportConfig);
            // console.log('setting', reportConfig, options);
            // @TODO DO something smart when options.includeallchecks is set.
            if(options.includeallchecks === false) commit('setChecksList', []);

            reportConfig.checks = "keep";

            return axios.post('/account/reporting/status', reportConfig)
                .then( (result) => {
                    this.dispatch('reports_statusevents/listChecks', { skipconfig: true });
                    if(result) commit('setError', false);
                })
                .catch( function (error){
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    commit('setError', {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        message: ((error.response.data && error.response.data.error) || "Report unavailable")
                    });
                })
        }
    }
}
